import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { Draggable } from "react-beautiful-dnd";
import { Card } from 'react-bootstrap';
import { isToday, usePermission } from "../../../helpers/common";
import { handleDragDrop } from '../../../actions/eg-kanban';
import { EG_OPTION_TYPES, DISPLAY_DATETIME_FORMAT } from '../../../constants';

const getItemStyle = (draggableStyle) => ({
    userSelect: 'none',
    ...draggableStyle,
});

const ColumnCard = (props) => {
    const { index, droppableId, isChanged, equipment, type, search, actions } = props;
    const allow = usePermission();
    const isAllowEdit = allow("equipment-group", "edit") ? isToday(search.range) : false;

    const handleUnassign = () => {
        const params = {
            sourceIndex: EG_OPTION_TYPES.indexOf(type),
            sourceId: droppableId,
            destIndex: 0,
            destId: type,
            draggableId: equipment.id
        };
        actions.handleDragDrop(params);
    }

    return (equipment && <Draggable
        key={index}
        draggableId={equipment.id}
        index={index}
        isDragDisabled={!isAllowEdit}
    >
        {(provided, snapshot) => (
            <div ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={getItemStyle(provided.draggableProps.style)}>
                <Card className={`${snapshot.isDragging ? "dragging" : ""} ${isChanged && "changed"}`}>
                    <div className="d-flex w-100">
                        <div className={`card-image ${type}`}>
                            <i className={`img-type ${equipment.icon}`} aria-hidden="true" />
                        </div>
                        <div className="card-name">
                            <span title={type === 'device' ? equipment.id : equipment.name}>{equipment.name}</span>
                            {equipment.subName && type !== 'operator' && <div className="card-sub-name">{equipment.subName}</div>}
                            {isToday(search.range) && !isChanged && equipment.subName && type === 'operator' && <div className="card-sub-name text-success">
                                Active from {moment(equipment.subName).format(DISPLAY_DATETIME_FORMAT)}</div>}
                        </div>
                        <div className="unassign-btn">
                            {isAllowEdit && <i className="fa fa-times" aria-hidden="true" title="Leave EG" onClick={handleUnassign} />}
                        </div>
                    </div>
                </Card>
            </div>)}
    </Draggable>
    )
}

const mapStateToProps = (state, ownProps) => {
    const { analyze, egKanban } = state;
    const egListById = egKanban.egListById.hasOwnProperty(ownProps.droppableId) ? egKanban.egListById[ownProps.droppableId] : null;
    const listById = egKanban.optionList[ownProps.type].listById;
    return ({
        isChanged: egListById ? egListById.list.indexOf(ownProps.id) < 0 : true,
        equipment: listById.hasOwnProperty(ownProps.id) ? listById[ownProps.id] : null,
        search: { range: analyze.searchParams.range }
    });
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        handleDragDrop
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ColumnCard);
